export default {
  buttons: {
    change_plan: 'Alterar plano',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_save_changes: 'Falha ao guardar alterações',
  },
};
